var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.role))]), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'titul',
      "value": _vm.summaryData.degree
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'meno',
      "value": _vm.summaryData.first_name
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'priezvisko',
      "value": _vm.summaryData.last_name
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obec',
      "value": _vm.summaryData.client_profile.permanent_address_city
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ulica',
      "value": _vm.summaryData.client_profile.permanent_address_street
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'súpisné č.',
      "value": _vm.summaryData.client_profile.permanent_address_popisne
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'orientačné č.',
      "value": _vm.summaryData.client_profile.permanent_address_number
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'PSČ',
      "value": _vm.summaryData.client_profile.permanent_address_zip
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'narodený',
      "value": _vm.transformDate(_vm.summaryData.client_profile.datum_narodenia)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'rodné č.',
      "value": _vm.summaryData.client_profile.rodne_cislo
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'príslušnosť',
      "value": _vm.summaryData.client_profile.statna_prislusnost
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'číslo OP',
      "value": _vm.summaryData.client_profile.op_cislo
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'OP do',
      "value": _vm.transformDate(_vm.summaryData.client_profile.op_platnost_do)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'OP vydaný',
      "value": _vm.transformDate(_vm.summaryData.client_profile.op_vytvoreny)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'rodinný stav',
      "value": _vm.summaryData.client_profile.rodinny_stav
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'vzdelanie',
      "value": _vm.summaryData.client_profile.vzdelanie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'členovia v dom.',
      "value": _vm.summaryData.client_profile.pocet_vyzivovanych_osob
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'počet detí',
      "value": _vm.summaryData.client_profile.pocet_nezaopatrenych_deti
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'bývam',
      "value": _vm.summaryData.client_profile.aktualne_byvate
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'telefón',
      "value": _vm.summaryData.client_profile.telephone
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'email',
      "value": _vm.summaryData.email
    }
  }), _vm.prednaStranaOP ? _c('file-download-holder', {
    attrs: {
      "cloud-file": _vm.prednaStranaOP,
      "label": 'Predná strana OP'
    }
  }) : _vm._e(), _vm.zadnaStranaOP ? _c('file-download-holder', {
    attrs: {
      "cloud-file": _vm.zadnaStranaOP,
      "label": 'Zadná strana OP'
    }
  }) : _vm._e()], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }